import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-category',
  templateUrl: './services-category.component.html',
  styleUrls: ['./services-category.component.scss']
})
export class ServicesCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
